// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios2 from 'utils/axios2';
import { dispatch } from '../index';

// ----------------------------------------------------------------------
// const apiHost = 'https://youteach.ai/api'
const apiHost = process.env.REACT_APP_API_URL;

const initialState = {
    error: null,
    personas: [],
    apikeys: []
};

const slice = createSlice({
    name: 'persona',
    initialState,
    reducers: {
        getPersona(state, action) {
            state.personas = action.payload;
        },
        getApiKeys(state, action) {
            state.apikeys = action.payload;
        },
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        }
    }
    // extraReducers(builder) {
    //     builder
    //         .addCase(fetchAnswer.pending, (state) => {
    //             state.status = 'loading';
    //         })
    //         .addCase(fetchAnswer.rejected, (state, action) => {
    //             state.status = 'failed';
    //             state.queries[state.queries.length - 1].error =
    //                 'Something went wrong. Please try again later.';
    //         });
    // },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function fetchPersonas(vector_id) {
    // const formData = new FormData()
    return async () => {
        try {
            const user_token = localStorage.getItem('user_token');
            const response = await axios2.get(`/api/persona?vector_id=${vector_id}`);
            dispatch(slice.actions.getPersona(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function insertPersonas(vector_id, persona_title, persona_content) {
    // const formData = new FormData()
    return async () => {
        try {
            const formData = new FormData();
            const user_token = localStorage.getItem('user_token');
            formData.append('user_token', user_token);
            formData.append('vector_id', vector_id);
            formData.append('persona_title', persona_title);
            formData.append('persona_content', persona_content);
            const response = await axios2.post(`/api/persona`, formData);
            dispatch(slice.actions.getPersona(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deletePersonas(vector_id, persona_id) {
    // const formData = new FormData()
    return async () => {
        try {
            const formData = new FormData();
            const user_token = localStorage.getItem('user_token');
            formData.append('user_token', user_token);
            formData.append('vector_id', vector_id);
            const response = await axios2.post(`/api/persona/delete/${persona_id}`, formData);
            dispatch(slice.actions.getPersona(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function activePersonas(vector_id, persona_id) {
    // const formData = new FormData()
    return async () => {
        try {
            const formData = new FormData();
            const user_token = localStorage.getItem('user_token');
            formData.append('user_token', user_token);
            formData.append('vector_id', vector_id);
            const response = await axios2.post(`/api/persona/active/${persona_id}`, formData);
            dispatch(slice.actions.getPersona(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function updatePersonas(vector_id, persona_id, persona_content) {
    // const formData = new FormData()
    return async () => {
        try {
            const formData = new FormData();
            const user_token = localStorage.getItem('user_token');
            formData.append('user_token', user_token);
            formData.append('vector_id', vector_id);
            formData.append('persona_id', persona_id);
            formData.append('persona_content', persona_content);
            const response = await axios2.post(`/api/persona/update`, formData);
            dispatch(slice.actions.getPersona(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
